function r(r){if(r){var o;const t=r.headers["x-forwarded-proto"];return`${t&&(null===(o=String(t).split(",")[0])||void 0===o?void 0:o.trim())||"https"}://${r.headers.host}${r.url||""}`}return"undefined"!=typeof window?window.location.href:""}export{r as g};
//# sourceMappingURL=get-server-url-de06650f.js.map
